export const WEBVIEW_AI_PROMPT = `너는 RealWorld Studio 웹뷰 액션용 HTML을 만드는 프론트엔드 개발자입니다.
아래 문서를 반드시 지켜서 모바일 WebView에서 바로 실행되는 단일 HTML 파일만 출력하세요.
설명, 마크다운 코드블록, 추가 문장은 출력하지 마세요. 최종 답변은 <!doctype html>로 시작하는 HTML 코드여야 합니다.

1. RealWorld Studio 웹뷰의 역할
- 웹뷰는 "액션 화면"입니다.
- 웹뷰 안에서 다음 화면, 퀘스트 완료, 미션 완료, 게임 종료 같은 처리를 직접 실행하지 않습니다.
- 웹뷰는 window.RealWorld.submitAction(...)으로 결과값만 스튜디오에 전달합니다.
- 전달된 결과값에 따라 RealWorld Studio의 "리액션"에서 퀘스트 완료, 미션 완료, 게임 종료, 다음 퀘스트 표시, 미션 이동 등을 설정합니다.

2. submitAction과 스튜디오 리액션 조건 매핑
- 조건 없이 다음 리액션을 실행하려면 성공 시점에 window.RealWorld.submitAction('')을 호출합니다.
- 이 경우 스튜디오 리액션 실행 조건은 "실행 조건 없음"으로 설정합니다.
- 정답/오답/분기처럼 결과값이 필요하면 window.RealWorld.submitAction('success'), window.RealWorld.submitAction('fail')처럼 명확한 영문 값을 보냅니다.
- 이 경우 스튜디오 리액션 실행 조건은 "특정 텍스트를 입력함"으로 설정하고, 입력값을 success 또는 fail처럼 웹뷰가 보내는 값과 똑같이 맞춥니다.

3. 자주 쓰는 스튜디오 리액션 예시
- 다음 퀘스트로 진행: 웹뷰에서 submitAction('') 호출 -> 리액션 조건 "실행 조건 없음" -> "퀘스트 완료 처리" + 필요 시 "퀘스트 버튼 표시"
- 숨김 퀘스트 열기: 웹뷰에서 submitAction('') 호출 -> 리액션 조건 "실행 조건 없음" -> "퀘스트 버튼 표시"에서 열 퀘스트 선택
- 미션 완료 처리: 웹뷰에서 submitAction('mission-complete') 호출 -> 리액션 조건 "특정 텍스트를 입력함: mission-complete" -> "미션 완료 처리"
- 게임 완료 처리: 웹뷰에서 submitAction('game-complete') 호출 -> 리액션 조건 "특정 텍스트를 입력함: game-complete" -> "게임 완료 처리" 또는 "게임 종료하기 버튼 추가"
- 다른 미션으로 이동: 웹뷰에서 submitAction('go-next-mission') 호출 -> 리액션 조건 "특정 텍스트를 입력함: go-next-mission" -> "특정 미션으로 이동 버튼 추가" 또는 "다음 미션 이동 / 표시 일괄 설정"
- 아이템 획득: 웹뷰에서 submitAction('item-earned') 호출 -> 리액션 조건 "특정 텍스트를 입력함: item-earned" -> "아이템 획득"
- 브라우저/영상/후기 열기: 웹뷰에서 submitAction('') 호출 -> 리액션 조건 "실행 조건 없음" -> "브라우저 열기 버튼 추가", "유튜브 재생 화면 열기", "후기 작성 화면 열기" 중 선택

4. HTML 작성 규칙
- HTML, CSS, JavaScript를 하나의 HTML 파일 안에 모두 포함합니다.
- React, Vite, npm 빌드가 필요한 코드는 쓰지 않습니다. 필요하면 CDN script만 사용합니다.
- 모바일 세로 화면 기준으로 만들고 viewport meta 태그를 포함합니다.
- 터치하기 쉬운 버튼 크기와 충분한 대비를 사용합니다.
- 외부 이미지/폰트/CDN이 실패해도 기본 기능이 동작하도록 만듭니다.
- 닫기 버튼이 필요하면 window.RealWorld.closePage()를 호출합니다.
- 완료/정답/성공 버튼은 반드시 window.RealWorld.submitAction(...)을 호출합니다.

5. 반드시 포함할 RealWorld 브릿지 코드
<script>
  window.RealWorld = window.RealWorld || {
    invoke(name, ...params) {
      if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers[name]) {
        window.webkit.messageHandlers[name].postMessage(params.length ? params[0] : '');
        return;
      }
      if (window.Android && typeof window.Android[name] === 'function') {
        if (params.length) {
          window.Android[name](...params);
        } else {
          window.Android[name]();
        }
      }
    },
    submitAction(input = '') {
      window.RealWorld.invoke('submitAction', input);
    },
    closePage() {
      window.RealWorld.invoke('closePage');
    }
  };
</script>

6. 이번에 만들 HTML 요구사항
- 화면에는 제목, 설명, 핵심 인터랙션, 완료 버튼이 있어야 합니다.
- 사용자가 완료 조건을 만족하거나 완료 버튼을 누르면 window.RealWorld.submitAction('')을 호출하세요.
- 정답/오답 분기가 필요한 문제라면 정답일 때 submitAction('success'), 오답일 때 submitAction('fail')을 호출하세요.
- 코드 안에 "스튜디오에서 설정할 리액션"을 HTML 주석으로 짧게 남기세요.
- RealWorld Studio 웹뷰 빌더의 [직접 만들기] 코드 영역에 그대로 붙여 넣을 수 있어야 합니다.`;

export const WEBVIEW_AI_GUIDE_MARKDOWN = `# RealWorld Studio 웹뷰 AI 제작 가이드

## 1. 핵심 개념

웹뷰는 RealWorld Studio의 "액션 화면"입니다. 퀘스트 완료, 미션 완료, 게임 종료, 다음 퀘스트 표시 같은 실제 게임 진행은 웹뷰 코드가 직접 처리하지 않고 Studio의 "리액션"이 처리합니다.

웹뷰 코드가 해야 할 일은 하나입니다.

\`\`\`js
window.RealWorld.submitAction('결과값');
\`\`\`

이 호출로 Studio에 결과값을 넘기면, Studio의 리액션 실행 조건이 그 값을 받아 다음 처리를 실행합니다.

## 2. submitAction 사용법

### 조건 없이 다음 리액션 실행

웹뷰에서 다음처럼 호출합니다.

\`\`\`js
window.RealWorld.submitAction('');
\`\`\`

Studio 설정:

- 리액션 실행 조건: \`실행 조건 없음\`
- 리액션 명령: 필요한 명령 선택

이 방식은 "완료 버튼을 누르면 무조건 다음 화면으로 넘어감" 같은 흐름에 씁니다.

### 값에 따라 분기

웹뷰에서 결과값을 보냅니다.

\`\`\`js
window.RealWorld.submitAction('success');
window.RealWorld.submitAction('fail');
\`\`\`

Studio 설정:

- 성공 리액션 실행 조건: \`특정 텍스트를 입력함\` = \`success\`
- 실패 리액션 실행 조건: \`특정 텍스트를 입력함\` = \`fail\`

값은 영문 소문자와 하이픈 조합을 권장합니다. 예: \`success\`, \`fail\`, \`timeout\`, \`game-complete\`, \`mission-complete\`.

## 3. 자주 쓰는 Studio 리액션 설정 예시

### 다음 퀘스트로 진행

웹뷰:

\`\`\`js
window.RealWorld.submitAction('');
\`\`\`

Studio:

- 조건: \`실행 조건 없음\`
- 명령: \`퀘스트 완료 처리\`
- 다음 퀘스트가 숨김 상태라면 명령에 \`퀘스트 버튼 표시\`도 추가

### 숨김 퀘스트 열기

웹뷰:

\`\`\`js
window.RealWorld.submitAction('');
\`\`\`

Studio:

- 조건: \`실행 조건 없음\`
- 명령: \`퀘스트 버튼 표시\`
- 표시할 퀘스트: 다음에 열 퀘스트 선택

### 미션 완료 처리

웹뷰:

\`\`\`js
window.RealWorld.submitAction('mission-complete');
\`\`\`

Studio:

- 조건: \`특정 텍스트를 입력함\` = \`mission-complete\`
- 명령: \`미션 완료 처리\`

### 게임 완료 처리

웹뷰:

\`\`\`js
window.RealWorld.submitAction('game-complete');
\`\`\`

Studio:

- 조건: \`특정 텍스트를 입력함\` = \`game-complete\`
- 명령: \`게임 완료 처리\`
- 플레이어에게 종료 버튼을 보여줘야 하면 \`게임 종료하기 버튼 추가\`도 사용

### 다른 미션으로 이동

웹뷰:

\`\`\`js
window.RealWorld.submitAction('go-next-mission');
\`\`\`

Studio:

- 조건: \`특정 텍스트를 입력함\` = \`go-next-mission\`
- 명령: \`특정 미션으로 이동 버튼 추가\` 또는 \`다음 미션 이동 / 표시 일괄 설정\`

### 정답/오답 분기

웹뷰:

\`\`\`js
if (isCorrect) {
  window.RealWorld.submitAction('success');
} else {
  window.RealWorld.submitAction('fail');
}
\`\`\`

Studio:

- 정답 리액션 조건: \`특정 텍스트를 입력함\` = \`success\`
- 오답 리액션 조건: \`특정 텍스트를 입력함\` = \`fail\`
- 정답 명령 예시: \`퀘스트 완료 처리\`, \`퀘스트 버튼 표시\`
- 오답 명령 예시: \`내용 추가\`, \`돌아가기 버튼 추가\`

### 아이템 획득/소모

웹뷰:

\`\`\`js
window.RealWorld.submitAction('item-earned');
\`\`\`

Studio:

- 조건: \`특정 텍스트를 입력함\` = \`item-earned\`
- 명령: \`아이템 획득\` 또는 \`아이템 소모\`

### 브라우저, 영상, 후기 화면 열기

웹뷰:

\`\`\`js
window.RealWorld.submitAction('');
\`\`\`

Studio:

- 조건: \`실행 조건 없음\`
- 명령: \`브라우저 열기 버튼 추가\`, \`유튜브 재생 화면 열기\`, \`후기 작성 화면 열기\` 중 선택

## 4. 생성형 AI에게 보낼 프롬프트

\`\`\`text
${WEBVIEW_AI_PROMPT}
\`\`\`

## 5. 최소 HTML 예시

\`\`\`html
<!doctype html>
<html lang="ko">
  <head>
    <meta charset="UTF-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0, viewport-fit=cover" />
    <title>RealWorld WebView</title>
    <style>
      body {
        margin: 0;
        min-height: 100vh;
        display: flex;
        align-items: center;
        justify-content: center;
        font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
        background: #f5f5f5;
      }
      main {
        width: min(100% - 32px, 420px);
        padding: 24px;
        background: #fff;
        border-radius: 12px;
      }
      button {
        width: 100%;
        min-height: 48px;
        border: 0;
        border-radius: 8px;
        background: #191919;
        color: #fff;
        font-size: 16px;
      }
    </style>
  </head>
  <body>
    <main>
      <h1>웹뷰 액션</h1>
      <p>완료 버튼을 누르면 조건 없음 리액션으로 넘어갑니다.</p>
      <button id="complete-button" type="button">완료</button>
    </main>
    <!--
      Studio 설정:
      - 리액션 실행 조건: 실행 조건 없음
      - 추천 명령: 퀘스트 완료 처리, 퀘스트 버튼 표시, 미션 완료 처리 등
    -->
    <script>
      window.RealWorld = window.RealWorld || {
        invoke(name, ...params) {
          if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers[name]) {
            window.webkit.messageHandlers[name].postMessage(params.length ? params[0] : '');
            return;
          }
          if (window.Android && typeof window.Android[name] === 'function') {
            if (params.length) {
              window.Android[name](...params);
            } else {
              window.Android[name]();
            }
          }
        },
        submitAction(input = '') {
          window.RealWorld.invoke('submitAction', input);
        },
        closePage() {
          window.RealWorld.invoke('closePage');
        }
      };

      document.getElementById('complete-button').addEventListener('click', function () {
        window.RealWorld.submitAction('');
      });
    </script>
  </body>
</html>
\`\`\`

## 6. 제작 전 체크리스트

- HTML 안에 \`window.RealWorld.submitAction\` 호출이 있는가?
- 조건 없음 리액션을 쓸 경우 \`submitAction('')\`을 호출하는가?
- 특정 텍스트 조건을 쓸 경우 웹뷰에서 보내는 값과 Studio 조건 값이 정확히 같은가?
- 숨김 퀘스트로 넘어가야 한다면 \`퀘스트 버튼 표시\` 리액션을 추가했는가?
- 미션/게임 완료가 필요하다면 \`미션 완료 처리\`, \`게임 완료 처리\` 리액션을 추가했는가?
- AI가 React/Vite/npm 프로젝트 형태로 답하지 않고 단일 HTML 파일로 답했는가?
`;
